import { StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type SubjectMasteryCardProps = {
  subjectName: string;
  masteryPercent: number;
  weakPoint: string;
  trendLabel: string;
};

export function SubjectMasteryCard({
  subjectName,
  masteryPercent,
  weakPoint,
  trendLabel,
}: SubjectMasteryCardProps) {
  return (
    <AppCard style={styles.card}>
      <View style={styles.header}>
        <View style={styles.titleWrap}>
          <AppText variant="subtitle" weight="bold">
            {subjectName}
          </AppText>
          <AppText variant="caption" tone="muted">
            {trendLabel}
          </AppText>
        </View>
        <AppText variant="subtitle" weight="bold" tone="primary">
          {masteryPercent}%
        </AppText>
      </View>

      <View style={styles.progressTrack}>
        <View style={[styles.progressFill, { width: `${masteryPercent}%` }]} />
      </View>

      <AppText variant="body" tone="muted">
        薄弱点：{weakPoint}
      </AppText>
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.md,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: tokens.spacing.md,
  },
  titleWrap: {
    flex: 1,
  },
  progressTrack: {
    height: tokens.layout.progressHeight,
    borderRadius: tokens.radius.full,
    overflow: 'hidden',
    backgroundColor: tokens.colors.surfaceMuted,
  },
  progressFill: {
    height: '100%',
    borderRadius: tokens.radius.full,
    backgroundColor: tokens.colors.primary,
  },
});
